import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { showMessage } from "../messages/messagesActions";
import { api } from "../../api/api";
import { ITotalRecords } from "./types";




export const  FETCH_STUDENT_RECORD_LIST_PROGRESS = "FETCH_STUDENT_RECORD_LIST_PROGRESS";
export const  FETCH_STUDENT_RECORD_LIST_SUCCESS = "FETCH_STUDENT_RECORD_LIST_SUCCESS";
export const  FETCH_STUDENT_RECORD_LIST_FAILED = "FETCH_STUDENT_RECORD_LIST_FAILED";


export const fetchStudentReportListProgress = () => 
    action(FETCH_STUDENT_RECORD_LIST_PROGRESS);

export const fetchStudentReportListSuccess = (data: ITotalRecords[],  singleReport: ITotalRecords,totalRecords: number,   ) =>
    action(FETCH_STUDENT_RECORD_LIST_SUCCESS, {
        data, singleReport, totalRecords,
    });

export const fetchStudentReportListFailed = () =>
    action(FETCH_STUDENT_RECORD_LIST_FAILED);


export const fetchStudentReportListAsync =
  ( 
       date: IDataTableV2DateState["dates"],
       organizationUUID: string,
        courseUUID?: string,
        batch?: string,
        acedmicYear?: number
       
 ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchStudentReportListProgress()); 

      let url =""
      if(organizationUUID){
        url+= `&organizations_uuid=${organizationUUID}`
      }
      if(courseUUID){
        url+= `&courses_uuid=${courseUUID}`
      }
       if (batch){
        url+= `&batch=${batch}` 
       }
       if(acedmicYear){
        url+= `&academic_year=${acedmicYear}`

       }
      const res = await api.get(
        `report/get-student-wise-Data?&from_date=${date.fromDate}&to_date=${date.toDate}`+url
      );

      const data: ITotalRecords[] = res.data.data;
      const singleRecord  = res.data.data[0];
        const totalRecords = res.data.totalRecords;
        
        dispatch(fetchStudentReportListSuccess(data, singleRecord, totalRecords, ));
       
    } catch (error: any) {
        dispatch(fetchStudentReportListFailed()); 
        dispatch(
            showMessage({
              type: "error",
              message: error.response.data.message,
              displayAs: "snackbar",
            })
        )
    }
}

// export const fetchStudentdeatiledReportListAsync =
//   ( 
//        date: IDataTableV2DateState["dates"],
//        organizationUUID: string,
//         courseUUID?: string,
//         batch?: string,
//         acedmicYear?: number
       
//  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
//   async (dispatch, getState) => {
//     try {
//       dispatch(fetchStudentReportListProgress()); 

//       let url =""
//       if(organizationUUID){
//         url+= `&organizations_uuid=${organizationUUID}`
//       }
//       if(courseUUID){
//         url+= `&courses_uuid=${courseUUID}`
//       }
//        if (batch){
//         url+= `&batch=${batch}` 
//        }
//        if(acedmicYear){
//         url+= `&academic_year=${acedmicYear}`

//        }
//       const res = await api.get(
//         `report/get-student-wise-detailed-Data?&from_date=${date.fromDate}&to_date=${date.toDate}`+url
//       );

//       const data: IStudentReport[] = res.data.data;
//       const singleReport  = res.data.data[0];
//         const totalRecords = res.data.totalRecords;
//         dispatch(fetchStudentReportListSuccess(data, singleReport, totalRecords,));
       
//     } catch (error: any) {
//         dispatch(fetchStudentReportListFailed()); 
//         dispatch(
//             showMessage({
//               type: "error",
//               message: error.response.data.message,
//               displayAs: "snackbar",
//             })
//         )
//     }
// }
  
